import { useState, FormEvent } from "react";
import { useAuth } from "../providers/authProvider";
import { SIGN_UP_URL } from "../api";

export const LoginScreen = () => {
  const { login } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | undefined>();
  const [loading, setLoading] = useState(false);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(undefined);
    const result = await login({ username, password });
    setLoading(false);
    if (!result.success) setError(result.error);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-neutral-50">
      <form onSubmit={submit} className="w-full max-w-sm space-y-4 p-6">
        <h1 className="text-2xl font-semibold">todoit</h1>
        <p className="text-sm text-neutral-500">
          Log in with your{" "}
          <a
            href={SIGN_UP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="underline"
          >
            doridium
          </a>{" "}
          account.
        </p>
        <input
          className="w-full border rounded px-3 py-2"
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
        <input
          className="w-full border rounded px-3 py-2"
          placeholder="Password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        {error && <p className="text-sm text-red-600">{error}</p>}
        <button
          className="w-full bg-neutral-900 text-white rounded px-3 py-2 disabled:opacity-50"
          disabled={loading}
        >
          {loading ? "Logging in…" : "Log in"}
        </button>
      </form>
    </div>
  );
};
